import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Comparateur from "./pages/Comparateur";
import NotFound from "./pages/NotFound";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Comparateur />} />
          <Route path="/comparateur" element={<Comparateur />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
